import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

export const Stars = ({ value = 0, size = "h-4 w-4" }) => (
  <span className="inline-flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={cn(size, i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-stone-300")} />
    ))}
  </span>
);

export const RatingSummary = ({ rating, count, testId = "rating-summary", className }) =>
  count > 0 ? (
    <span className={cn("inline-flex items-center gap-1 text-sm", className)} data-testid={testId}>
      <Star className="h-4 w-4 fill-amber-400 text-amber-400" />
      <b className="text-stone-900">{Number(rating).toFixed(1).replace(".", ",")}</b>
      <span className="text-stone-500">({count} ulasan)</span>
    </span>
  ) : (
    <span className={cn("text-xs text-stone-400", className)} data-testid={testId}>Belum ada ulasan</span>
  );

export const RatingInput = ({ value, onChange, testId = "rating-input" }) => (
  <div className="flex gap-1" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((i) => (
      <button key={i} type="button" onClick={() => onChange(i)} data-testid={`${testId}-${i}`} className="transition-transform hover:scale-110">
        <Star className={cn("h-8 w-8", i <= value ? "fill-amber-400 text-amber-400" : "text-stone-300")} />
      </button>
    ))}
  </div>
);
